import * as h from "react";
import { i as d, E as x, x as c, a as u, r as g, c as b } from "../createReactComponent-58f9bea8.mjs";
import { n as a } from "../property-9daa16cd.mjs";
import { e as m } from "../class-map-2994e95e.mjs";
import { r as w } from "../icon-c572aa57.mjs";
const f = d`
  :host .alert-popup {
    position: relative;
    padding: var(--exo-spacing-x-small);
    box-sizing: border-box;
    box-shadow: var(--exo-box-shadow-moderate);
    cursor: pointer;
    font: var(--exo-text-body-medium);
    color: var(--exo-color-font);
    outline: none;
    text-align: left;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: var(--exo-size-3);
    display: none;
  }

  :host .alert-popup.alert-popup--show {
    display: flex;
  }

  :host .alert-popup__text {
    word-break: break-word;
    display: inline-block;
    flex: 1;
    padding: 0 var(--exo-spacing-x-small);
  }

  :host .alert-popup .alert-popup__close {
    font-size: var(--exo-font-size-medium);
  }

  :host .alert-popup .alert-popup__icon {
    font-size: var(--exo-font-size-5x-large);
  }

  :host .alert-popup.alert-popup--info {
    background-color: var(--exo-color-background-info);
  }

  :host .alert-popup.alert-popup--success {
    background-color: var(--exo-color-background-success);
  }

  :host .alert-popup.alert-popup--warning {
    background-color: var(--exo-color-background-warning);
  }

  :host .alert-popup.alert-popup--error {
    background-color: var(--exo-color-border-danger-weak);
  }
`;
var y = Object.defineProperty, v = Object.getOwnPropertyDescriptor, l = (o, e, s, r) => {
  for (var n, t = r > 1 ? void 0 : r ? v(e, s) : e, i = o.length - 1; i >= 0; i--)
    (n = o[i]) && (t = (r ? n(e, s, t) : n(t)) || t);
  return r && t && y(e, s, t), t;
}, k = ((o) => (o.INFO = "info", o.SUCCESS = "success", o.WARNING = "warning", o.ERROR = "error", o))(k || {});
const A = { info: "Information", success: "Success", warning: "Warning", error: "Error" };
class p extends x {
  constructor() {
    super(), this.type = "info", this.showAlert = !0, this.hideClose = !1, this.alertPopupIconLabel = "", this.showAlert = !1;
  }
  attributeChangedCallback(e, s, r) {
    super.attributeChangedCallback(e, s, r), e === "showAlert" && (this.showAlert = r !== null);
  }
  close() {
    this.showAlert = !1, this.dispatchEvent(new CustomEvent("onClose"));
  }
  getAlertPopupIcon() {
    return this.type ? c`<ex-icon
          class="alert-popup__icon"
          icon=${A[this.type]}
          label=${this.alertPopupIconLabel}
        ></ex-icon>` : u;
  }
  closeAlertPopup() {
    return this.hideClose ? u : c`<ex-icon
          class="alert-popup__close"
          icon="Close"
          @click=${this.close}
          aria-label="close"
          aria-description="closes the alert popup"
        ></ex-icon>`;
  }
  render() {
    return c`
      <div
        class=${m({ "alert-popup": !0, "alert-popup--info": this.type === "info", "alert-popup--success": this.type === "success", "alert-popup--warning": this.type === "warning", "alert-popup--error": this.type === "error", "alert-popup--show": this.showAlert })}
        aria-hidden="${!this.showAlert}"
      >
        ${this.getAlertPopupIcon()}
        <slot class="alert-popup__text"></slot>
        ${this.closeAlertPopup()}
      </div>
    `;
  }
}
p.styles = f, l([a()], p.prototype, "type", 2), l([a({ type: Boolean })], p.prototype, "showAlert", 2), l([a({ type: Boolean })], p.prototype, "hideClose", 2), l([a({ type: String })], p.prototype, "alertPopupIconLabel", 2);
const C = (o = "") => {
  g("ex-alert-popup", p, o), w(o);
}, z = b({ tagName: "ex-alert-popup", elementClass: p, react: h, events: { onClose: "onClose" }, displayName: "ExAlertPopup", registerWebComponent: C });
export {
  k as AlertPopupType,
  z as ExAlertPopup,
  C as register
};
